// Copyright 2019 Sorama B.V.

import { IModal } from "libraries/WorkflowFramework/Interfaces/IModal";
import { IWorkflowModuleModalInstance } from "libraries/WorkflowFramework/Interfaces/IWorkflowModule";

export class HelpModal implements IModal<HelpModalState> {
    public state: HelpModalState;
    private viewModel: unknown;

    public activateModal(state: HelpModalState, modalInstance: IWorkflowModuleModalInstance<HelpModalState>): void {
        this.state = state;
    }

    public deactivate(): HelpModalState {
        return this.state;
    }

    public updateState(newState: HelpModalState): void {
        this.state = newState;
    }
}

export class HelpModalState {
    public htmlPath: string;
    public highlightName?: string;
}
